<template>
  <v-container>
    <v-alert prominent class="ma-10" outlined type="error">
      <div class="text-h3">Network Error</div>
      
      <div class="text-body-1">Oops! something went wrong. The administrator has been informed, please try again later.</div>
    </v-alert>
  </v-container>
</template>

<script>
export default {};
</script>

<style>
</style>